/* eslint-disable @typescript-eslint/no-var-requires */
import React, { useState } from 'react';
import { usePlayFlag } from './../../components/topicScroll';
import ImgPoint from '../../../../../assets/animation_point.gif';
import ImgArrowLeft from '../../../../../assets/arrow-left-long.png';
import ImgArrowRight from '../../../../../assets/arrow-right-long.png';

import './animation023.less';
import { Button, Modal } from 'antd';

interface IAnimation023SubItem {
  img: string;
  title: string;
  content: string;
}
interface IAnimation023Item {
  img1: string;
  img2: string;
  text: string;
  subtitle?: string;
  subItems?: IAnimation023SubItem[];
}

interface IAnimation023Props {
  items: IAnimation023Item[];
  className?: string;
  onCompleted?: () => void;
}

const Animation023: React.FunctionComponent<IAnimation023Props> = ({
  items,
  className,
  onCompleted,
}) => {
  const crrRef = React.useRef() as React.MutableRefObject<HTMLDivElement>;
  const playFlag = usePlayFlag(crrRef.current as HTMLElement, '.course-body');
  const [play, setPlay] = React.useState(1);

  const [isModalOpen, setModalOpen] = useState(false);
  const [currPage, setCurrPage] = useState(0);
  const [modalItem, setModalItem] = useState<IAnimation023SubItem[]>();
  const [show, setShow] = useState(true);
  const [show1, setShow1] = useState(true);
  const [show2, setShow2] = useState(true);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const setPage = (pagePlus: number) => {
    setCurrPage(currPage + pagePlus);
  };

  const startPlay = (next = 2) => {
    setPlay(next);
    next += 1;
    if (next <= items.length) {
      setTimeout(() => startPlay(next), 1500);
    } else {
      onCompleted && onCompleted();
    }
  };

  React.useEffect(() => {
    if (playFlag && play <= 1) {
      startPlay();
    }
  }, [playFlag]);

  React.useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const clickToPlay = () => {
    if (play <= 1) {
      startPlay();
    }
  };

  return (
    <div ref={crrRef} className={`animation023 component ${className || ''}`}>
      <img
        className="click-point1"
        onClick={() => clickToPlay()}
        style={{
          display: play <= 1 ? 'block' : 'none',
        }}
        src={ImgPoint}
        alt=""
      />
      {items.map((itm: IAnimation023Item, idx: number) => (
        <div key={idx} className="animation023-contaner">
          <div
            onClick={() => clickToPlay()}
            className={`animation023-item r${idx + 1} animation ${
              play >= idx + 1 ? 'fade-in' : ''
            }`}
          >
            <img
              src={
                windowWidth > 1500 || windowWidth <= 1024
                  ? require(`../../../../../assets/${itm.img1}`).default
                  : require(`../../../../../assets/${itm.img2}`).default
              }
              alt=""
            />
            <div className="text">
              <div dangerouslySetInnerHTML={{ __html: itm.text }} />
              {itm.subtitle ? (
                <span className="sub-task-text">
                  <Button
                    style={{ fontSize: '1.4rem' }}
                    type="link"
                    onClick={(e) => {
                      e.stopPropagation();
                      setModalOpen(true);
                      setModalItem(itm.subItems);
                      setShow2(false);
                    }}
                  >
                    {itm.subtitle}
                    <img
                      className="click-point"
                      hidden={!show2}
                      src={ImgPoint}
                      alt=""
                    />
                  </Button>
                </span>
              ) : null}
            </div>
          </div>
        </div>
      ))}
      {modalItem && (
        <Modal
          width="80%"
          className="animation023-modal-startup"
          title={
            <div className="animation023-modal-header">
              {modalItem[currPage]?.title}
            </div>
          }
          footer={null}
          open={isModalOpen}
          onCancel={() => setModalOpen(false)}
        >
          <div className="border">
            <img
              src={
                require(`../../../../../assets/${modalItem[currPage]?.img}`)
                  .default
              }
              alt=""
            />
          </div>
          <div
            className="content"
            dangerouslySetInnerHTML={{ __html: modalItem[currPage]?.content }}
          />
          <Button
            className={`prev-button ${currPage === 0 ? 'hide' : ''}`}
            type="text"
            disabled={currPage === 0}
            onClick={() => {
              setPage(-1);
              setShow(false);
            }}
          >
            <img className="arrow" src={ImgArrowLeft} alt="" />
            <img
              className="click-point1"
              hidden={!show}
              src={ImgPoint}
              alt=""
            />
          </Button>

          <Button
            className={`next-button ${
              currPage === modalItem.length - 1 ? 'hide' : ''
            }`}
            type="text"
            disabled={currPage === modalItem.length - 1}
            onClick={() => {
              setPage(1);
              setShow1(false);
            }}
          >
            <img className="arrow" src={ImgArrowRight} alt="" />
            <img
              className="click-point2"
              hidden={!show1}
              src={ImgPoint}
              alt=""
            />
          </Button>
        </Modal>
      )}
    </div>
  );
};

export default Animation023;
